"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearSystemTimeOffset = exports.useSystemTimeOffset = exports.getSystemTimeOffset = exports.getServerDate = void 0;
const Sentry = __importStar(require("@sentry/react"));
const react_1 = require("react");
const serverConfig_1 = require("./serverConfig");
const LOCAL_STORAGE_KEY = "systemTimeOffset";
let systemTimeStoredValue = localStorage.getItem(LOCAL_STORAGE_KEY);
let systemTimeOffset = systemTimeStoredValue === null ? null : parseInt(systemTimeStoredValue);
// If we don't have a stored server time, fetch one after 9 seconds. This prevents it from slowing
// down loading, but should speed up the first request to the API.  If the API gets called earlier,
// it will grab it then.
if (systemTimeOffset === null) {
    setTimeout(fetchServerTime, 9 * 1000);
}
function getServerDate() {
    return __awaiter(this, void 0, void 0, function* () {
        return new Date(new Date().getTime() + (yield getSystemTimeOffset()));
    });
}
exports.getServerDate = getServerDate;
function getSystemTimeOffset() {
    return __awaiter(this, void 0, void 0, function* () {
        if (systemTimeOffset === null) {
            yield fetchServerTime();
        }
        return systemTimeOffset;
    });
}
exports.getSystemTimeOffset = getSystemTimeOffset;
function useSystemTimeOffset() {
    const [systemTimeOffset, setSystemTimeOffset] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        function getSystemTime() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    setSystemTimeOffset(yield getSystemTimeOffset());
                }
                catch (e) {
                    setError(e);
                }
            });
        }
        getSystemTime();
    }, []);
    const loading = systemTimeOffset === null && error === null;
    return {
        loading,
        error,
        systemTimeOffset,
    };
}
exports.useSystemTimeOffset = useSystemTimeOffset;
function clearSystemTimeOffset() {
    systemTimeOffset = null;
    localStorage.removeItem(LOCAL_STORAGE_KEY);
}
exports.clearSystemTimeOffset = clearSystemTimeOffset;
function fetchServerTime() {
    return __awaiter(this, void 0, void 0, function* () {
        if (systemTimeOffset !== null) {
            return systemTimeOffset;
        }
        try {
            // Get a brand new timestamp from the server.
            const config = yield (0, serverConfig_1.getServerConfig)(true);
            systemTimeOffset = config.date.getTime() - config._retrievedAt.getTime();
            if (systemTimeOffset.toString() !== NaN.toString()) {
                localStorage.setItem(LOCAL_STORAGE_KEY, systemTimeOffset.toString());
                console.log("Setting systemTimeOffset: ", systemTimeOffset);
            }
        }
        catch (e) {
            console.log(e);
            // No need to start throwing errors and complicate things more. But we do want to record this
            // in case the server time strategy we're using stops working.
            Sentry.captureException(e);
            systemTimeOffset = 0;
        }
    });
}
//# sourceMappingURL=data:application/json;base64,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